import { gql } from "@apollo/client";

export const SEARCH_INSURANCE_COMPANIES = gql`
  query SearchInsuranceCompanies($searchTerm: String!) {
    searchInsuranceCompanies(searchTerm: $searchTerm) {
      id
      name
      number
    }
  }
`;

